import { ModalPreferences } from "./modal-preferences.js";
import { ulid } from "ulid";
import isbot from "isbot";
import React from "react";
export const ConsentContext = React.createContext({});
ConsentContext.displayName = "ConsentContext";
export const ConsentProvider = ({ consent: injectedConsent, children, groups, processes, storageKey, }) => {
    const makeDefault = () => {
        const userDefault = {
            id: ulid(),
            given: false,
            grants: processes.filter(({ required }) => required),
            ts: Date.now(),
            user: {
                ipAddress: "",
                userAgent: "",
            },
            version: 0,
        };
        // we add all grants by default for search engine crawlers / bots
        const botDefault = {
            id: ulid(),
            given: true,
            grants: processes,
            ts: Date.now(),
            user: {
                ipAddress: "",
                userAgent: "",
            },
            version: 0,
        };
        if (typeof window === "undefined")
            return userDefault;
        return isbot(navigator.userAgent) ? botDefault : userDefault;
    };
    const fromLocalStorage = () => {
        if (typeof window === "undefined")
            return;
        const savedValue = localStorage.getItem(storageKey);
        if (!savedValue)
            return;
        return JSON.parse(savedValue);
    };
    const toLocalStorage = React.useCallback((value) => {
        if (typeof window === "undefined")
            return;
        localStorage.setItem(storageKey, JSON.stringify(value));
    }, [storageKey]);
    const [consent, setConsent] = React.useState(injectedConsent ?? fromLocalStorage() ?? makeDefault());
    React.useEffect(() => {
        toLocalStorage(consent);
    }, [consent, toLocalStorage]);
    const [showPreferences, setShowPreferences] = React.useState(false);
    const openPreferences = () => setShowPreferences(true);
    const closePreferences = () => setShowPreferences(false);
    React.useEffect(() => {
        if (typeof window === "undefined")
            return;
        setShowPreferences(!consent.given);
    }, []);
    const setGrants = React.useCallback((grants) => setConsent((curr) => ({
        ...curr,
        given: true,
        ts: Date.now(),
        grants,
        version: curr.version + 1,
    })), [setConsent]);
    const addGrant = (grant) => setGrants(consent.grants.includes(grant) ? consent.grants : [...consent.grants, grant]);
    const removeGrant = (grant) => setGrants(consent.grants.filter(({ id }) => grant.id !== id));
    const hasGrant = (grant) => consent.grants.some(({ id }) => grant.id === id);
    return (React.createElement(ConsentContext.Provider, { value: {
            addGrant,
            closePreferences,
            consent,
            groups,
            hasGrant,
            openPreferences,
            processes,
            removeGrant,
            setGrants,
        } },
        children,
        React.createElement(ModalPreferences, { open: showPreferences })));
};
//# sourceMappingURL=provider.js.map